//kendo
import { Window } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';

const AlertWindowItem = ({ item, index, today }) => {
  const [visible, setVisible] = useState(true);
  const alertWindowWidth = 430;
  const alertWindowHeight = 90;
  const innerWidth = window.innerWidth - 20;
  const innerHeight = window.innerHeight - 20;
  const history = useHistory();
  /* 알림이력  */
  const dongCode = item.dongCode;
  const dongTermSimple = item.dongTerm;
  const elderTerm = item.elderTerm;
  const startDtm = item.ocurDtm;
  const endDtm = item.ocurDtm;

  const onCloseEvt = () => {
    setVisible(false);
  };

  const alertBtnClickEvt = () => {
    history.push({
      pathname: '/log/alert',
      state: { dongCode, dongTermSimple, elderTerm, startDtm, endDtm },
    });
    onCloseEvt();
  };
  useEffect(() => {
    setVisible(true);
  }, [today]);
  return (
    <>
      {visible && (
        <Window
          className="footerAlertWindow"
          title={null}
          width={alertWindowWidth}
          height={alertWindowHeight}
          left={innerWidth - alertWindowWidth - 20 * index}
          initialTop={90}
          onClose={onCloseEvt}>
          <div className="alertWindow" onClick={alertBtnClickEvt}>
            <img className="alertDangerImg" src="/images/dangerAlert.png"></img>
            <div className="userTermDiv">{item.elderTerm} 어르신</div>
            <div className="eventTermDiv">
              <span className="eventTermSpan1">응급신호({item.eventTypeTerm === '음성인식' ? '음성' : item.eventTypeTerm})</span>
              <span className="eventTermSpan2"> 이(가) 감지되었습니다.</span>
            </div>
            <img 
              className="alertCloseImg"
              src="/images/close.png"
              onClick={(event) => {
                event.stopPropagation();
                onCloseEvt();
              }}>
            </img>
          </div>
          {/* <div>
            <span className="alertWindowSignSpan">응급신호({item.eventTypeTerm === '음성인식' ? '음성' : item.eventTypeTerm})</span>이(가)
            감지되었습니다.
          </div>
          <div>상황 확인이 필요합니다.</div>
          <div className="alertWindowLastDiv">
            <span>{item.elderPhone}</span>
            <span>{item.ocurDtm}</span>
          </div>
          <div>
            <Button icon="search" className="footerAlertWindowBtn" onClick={alertBtnClickEvt}>
              이력관리 페이지
            </Button>
          </div> */}
        </Window>
      )}
    </>
  );
};

export default AlertWindowItem;
{/* <Window
          className="footerAlertWindow"
          title="위험 발생"
          width={alertWindowWidth}
          height={alertWindowHeight}
          left={innerWidth - alertWindowWidth - 20 * index}
          initialTop={90}
          onClose={onCloseEvt}>
          <div>
            <span className="alertWindowNameSpan">{item.elderTerm} 대상자</span>님
          </div>
          <div>
            <span className="alertWindowSignSpan">응급신호({item.eventTypeTerm === '음성인식' ? '음성' : item.eventTypeTerm})</span>이(가)
            감지되었습니다.
          </div>
          <div>상황 확인이 필요합니다.</div>
          <div className="alertWindowLastDiv">
            <span>{item.elderPhone}</span>
            <span>{item.ocurDtm}</span>
          </div>
          <div>
            <Button icon="search" className="footerAlertWindowBtn" onClick={alertBtnClickEvt}>
              이력관리 페이지
            </Button>
          </div>
        </Window> */}